module.exports = __webpack_public_path__ + "img/section4_pic1.8f8cff31.png";